import { defineStore } from 'pinia'
import client from '@/api/client'
import config from '@/config'
export const useNewsStore = defineStore('news', {
  state: () => ({
    news: [],
    pagination: {
      total: 0,
      currentPage: 1,
      totalPages: 1,
      limit: 10
    }
  }),
  getters: {
    getCurrentPage: state => state.pagination.currentPage,
    getTotalPages: state => state.pagination.totalPages
  },
  actions: {
    async fetchNews(page = 1, limit = 10) {
      try {
        const API_URL = `${config.apiBaseUrl}/news?page=${page}&limit=${limit}`
        const response = await client.get(API_URL)

        this.news = response.data.news || []
        this.pagination = response.data.pagination || {
          total: this.news.length,
          currentPage: +page,
          totalPages: 1,
          limit
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  }
})
